import { mergeListItem } from "../helpers/listItemMerge";

const atualizarRequisicoes = (state, requisicoes) => {
    state.requisicoes = requisicoes;
}

const atualizarRequisicoesBaixa = (state, requisicoesBaixa) => {
    state.requisicoesBaixa = requisicoesBaixa;
}

const atualizarRequisicao = (state, requisicao) => {
    state.requisicao = requisicao;
}

const addRequisicao = (state, requisicao) => {
    if (!requisicao || requisicao.id == null) return;

    state.requisicoes.push(JSON.parse(JSON.stringify(requisicao)));
    //alert(JSON.stringify(state.produtos));
}

const updateRequisicao = (state, requisicao) => {
    if (!requisicao || requisicao.id == null) return;

    const index = state.requisicoes.findIndex(item => item.id === requisicao.id);
    if (index >= 0) {
        state.requisicoes.splice(index, 1, mergeListItem(state.requisicoes[index], requisicao));
    }
    //alert(JSON.stringify(state.produtos));
}

const updateRequisicaoBaixa = (state, requisicao) => {
    if (!requisicao || requisicao.id == null) return;

    const index = state.requisicoesBaixa.findIndex(item => item.id === requisicao.id);
    if (index >= 0) {
        state.requisicoesBaixa.splice(index, 1, mergeListItem(state.requisicoesBaixa[index], requisicao));
    }
    //alert(JSON.stringify(state.produtos));
}

export default {
    atualizarRequisicoes,
    atualizarRequisicoesBaixa,
    atualizarRequisicao,
    addRequisicao,
    updateRequisicao,
    updateRequisicaoBaixa
}
